import { LanguageCode } from '$/store/languageStore/types';
import { getIsOverseaByCountryCode } from '$/common/utils/countryCodeUtil';
import type { OfficialHomeLanguage } from '@/components/overseaHome/types';

/** 官网语言仅由地区决定，不读取历史官网 Cookie、工作台偏好或浏览器语言。 */
export function getOfficialHomeLanguage(countryCode: string): OfficialHomeLanguage {
  // 与官网入口分流保持一致：CN / HK / MO / TW 使用中文，其余地区使用英文。
  return getIsOverseaByCountryCode(countryCode.trim().toUpperCase() || 'CN')
    ? LanguageCode.en
    : LanguageCode.zhHans;
}

/** 只识别两个官网首页的内部路径，防止工作台子页面误用官网运行时。 */
export function isOfficialHomePath(pathname: string): boolean {
  return pathname === '/--roboneo' || pathname === '/--oversea';
}

/** 国内官网固定进入新版首页，保留目标地址的查询参数和锚点，不读取旧版首页偏好。 */
export function getDomesticOfficialHomeRedirectUrl(countryCode: string, isDevelopment: boolean, asPath: string): string | null {
  if (getIsOverseaByCountryCode(countryCode.trim().toUpperCase() || 'CN')) return null;

  // 客户端导航尚未提交时，window.location 可能仍是来源页，因此从目标 asPath 提取参数。
  const suffixIndex = asPath.search(/[?#]/);
  const suffix = suffixIndex >= 0 ? asPath.slice(suffixIndex) : '';
  return `${isDevelopment ? '/--roboneo/home' : '/home'}${suffix}`;
}
